import { render, staticRenderFns } from "./sba-panel.vue?vue&type=template&id=34d3ce4e&"
import script from "./sba-panel.vue?vue&type=script&lang=js&"
export * from "./sba-panel.vue?vue&type=script&lang=js&"
import style0 from "./sba-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports